// saga.js
import { all, takeEvery, put } from 'redux-saga/effects';
import SuperFetch from '@iso/lib/helpers/superFetch';

import emailCampaignActions from './actions';

const DEFAULT_QUERY = {
  limit: 10,
  skip: 0,
  populate: [],
  sort: '_id',
  direction: 'desc',
};

function* getEmailCampaigns({ payload }) {
  try {
    const response = yield SuperFetch.get('/email-campaigns', {
      ...DEFAULT_QUERY,
      ...payload,
    });

    yield put(emailCampaignActions.setEmailCampaigns({
      data: response.data,
      total: response.total,
      pageSize: response.pageSize,
      totalPages: response.totalPages,
    }));
  } catch (err) {
    yield put({
      type: emailCampaignActions.EMAIL_CAMPAIGN_ERROR,
      payload: err.message,
    });
  }
}

function* getEmailCampaign({ payload: campaignId }) {
  try {
    const response = yield SuperFetch.get(`/email-campaigns/${campaignId}`);
    yield put(emailCampaignActions.setEmailCampaign(response));
  } catch (err) {
    yield put({
      type: emailCampaignActions.EMAIL_CAMPAIGN_ERROR,
      payload: err.message,
    });
  }
}

function* getEmailCampaignSummary({ payload: campaignId }) {
  try {
    const response = yield SuperFetch.get(`/email-campaigns/${campaignId}/summary`);
    yield put(emailCampaignActions.setEmailCampaignSummary(response));
  } catch (err) {
    yield put({
      type: emailCampaignActions.EMAIL_CAMPAIGN_ERROR,
      payload: err.message,
    });
  }
}

function* getEmailCampaignCompanies({ payload }) {
  console.log('payload', payload);
  try {
    const { campaignId, getAll } = payload;
    console.log('campaignId', campaignId);
    const query = {
      limit: 0,
    };
    if (getAll) {
      query.filter = 'getAll';
      query.getAll = true;
    }
    const response = yield SuperFetch.get(`/email-campaigns/${campaignId}/companies`, query);
    yield put(emailCampaignActions.setEmailCampaignCompanies({
      data: response.data,
      overview: response.overview
    }));
  } catch (err) {
    yield put({
      type: emailCampaignActions.EMAIL_CAMPAIGN_ERROR,
      payload: err.message,
    });
  }
}

function* createOrUpdateEmailCampaign({ payload }) {
  try {
    const { id, ...restBody } = payload;
    if (!id) {
      // Create one
      const campaign = yield SuperFetch.post('/email-campaigns', payload);
      return yield put(emailCampaignActions.createEmailCampaign(campaign));
    }

    // Update existed one
    const campaign = yield SuperFetch.put(`/email-campaigns/${payload.id}`, restBody);
    return yield put(emailCampaignActions.updateEmailCampaign(campaign));
  } catch (err) {
    yield put({
      type: emailCampaignActions.EMAIL_CAMPAIGN_ERROR,
      payload: err.message,
    });
  }
}

function* deleteEmailCampaign({ payload }) {
  try {
    const campaign = yield SuperFetch.delete(`/email-campaigns/${payload.id}`);
    return yield put(emailCampaignActions.deleteEmailCampaign(campaign));
  } catch (err) {
    yield put({
      type: emailCampaignActions.EMAIL_CAMPAIGN_ERROR,
      payload: err.message,
    });
  }
}

function* refreshEmailCampaignStats({ payload: campaignId }) {
  try {
    // Gọi API refresh stats
    yield SuperFetch.post(`/email-campaigns/${campaignId}/refresh-stats`);

    // Sau đó gọi API lấy thông tin chi tiết chiến dịch để cập nhật toàn bộ dữ liệu
    const response = yield SuperFetch.get(`/email-campaigns/${campaignId}`);

    // Cập nhật state với dữ liệu mới
    yield put(emailCampaignActions.refreshEmailCampaignStats(response));
    yield put(emailCampaignActions.setEmailCampaign(response));

    // Gọi thêm API lấy thông tin công ty của chiến dịch
    yield put(emailCampaignActions.getEmailCampaignCompanies(campaignId));

    // Gọi thêm API lấy thông tin tổng quan
    yield put(emailCampaignActions.getEmailCampaignSummary(campaignId));
  } catch (err) {
    yield put({
      type: emailCampaignActions.EMAIL_CAMPAIGN_ERROR,
      payload: err.message,
    });
  }
}

export default function* emailCampaignSaga() {
  yield all([
    takeEvery(emailCampaignActions.GET_EMAIL_CAMPAIGNS, getEmailCampaigns),
    takeEvery(emailCampaignActions.GET_EMAIL_CAMPAIGN, getEmailCampaign),
    takeEvery(emailCampaignActions.GET_EMAIL_CAMPAIGN_SUMMARY, getEmailCampaignSummary),
    takeEvery(emailCampaignActions.GET_EMAIL_CAMPAIGN_COMPANIES, getEmailCampaignCompanies),
    takeEvery(emailCampaignActions.CREATE_OR_UPDATE_EMAIL_CAMPAIGN_WATCHER, createOrUpdateEmailCampaign),
    takeEvery(emailCampaignActions.DELETE_EMAIL_CAMPAIGN_WATCHER, deleteEmailCampaign),
    takeEvery(emailCampaignActions.REFRESH_EMAIL_CAMPAIGN_STATS_WATCHER, refreshEmailCampaignStats),
  ]);
}
